import 'core-js/es6/map';
import 'core-js/es6/set';

import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import App from './components/AppContainer';
import './index.scss';
import reducer from './redux/modules';
import createInitialState from './redux/state/createInitialState';
import { updateButtonState } from './redux/actions/buttonStateByCId';
import RexCampaignEntryButtonStatusProvider from './components/RexCampaignEntryButtonStatusProvider';

if (typeof window !== 'undefined' && window.rexButtons && window.rexButtons.length) {
  const uniqueChecks = {};
  const rexButtons = window.rexButtons;

  // Create initial state from config
  const initialState = createInitialState(rexButtons);

  /* eslint-disable no-underscore-dangle */
  const store = createStore(
    reducer,
    initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );
  /* eslint-enable no-underscore-dangle */

  // Provide button status mainly for debugger
  window.RexCampaignEntryButtonStatusProvider = new RexCampaignEntryButtonStatusProvider(store.getState);

  // Subscribe to __REX_CEB_DEBUGGER_EVENT__ event for debugger
  const targetElm = document.body;
  targetElm.addEventListener('__REX_CEB_DEBUGGER_EVENT__', e => {
    const { state, cId } = e.detail;
    if (state && cId) {
      store.dispatch(updateButtonState(state, cId));
    }
  });

  for (let i = 0; i < rexButtons.length; i += 1) {
    const el = document.getElementById(rexButtons[i].id);

    if (el) {
      ReactDOM.render(
        <Provider store={store}>
          <App rexButton={rexButtons[i]} shouldCheck={!Object.hasOwnProperty.call(uniqueChecks, rexButtons[i].cId)} />
        </Provider>,
        el
      );
    }

    if (!Object.hasOwnProperty.call(uniqueChecks, rexButtons[i].cId)) {
      uniqueChecks[rexButtons[i].cId] = 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/index.js